export enum LeadFormType {
  ZEUS = 'ZEUS',
  BATTERY = 'BATTERY',
  GOOGLE_SHEETS = 'GOOGLE-SHEETS',
}

export const getFormType = (formType: string | undefined) => {
  return formType
    ? formType.toUpperCase().replace(/\s+/g, '-').replace(/\s/g, '')
    : LeadFormType.ZEUS;
};
